<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { tooltip, RICH_TOOLTIP_CLASS } from "@kontextwerk/web-sdk/core/overlay/tooltip"
  import { comparisonTooltip, type ContactComparison } from "../../_logic/contact-comparison"
  let { value }: { value: ContactComparison } = $props()
</script>
<div
  class="contact-comparison"
  tabindex="0"
  role="group"
  aria-label={`${value.side}: ${value.label}${value.subLabel ? ` · ${value.subLabel}` : ""}`}
  use:tooltip={{ content: comparisonTooltip(value), className: RICH_TOOLTIP_CLASS }}
>
  <StatusTag
    size="sm"
    label={value.label}
    subLabel={value.subLabel}
    icon={value.icon}
    color="neutral"
    disableTitle={true}
  />
  {#if value.hint}<span class="contact-comparison__hint">{value.hint}</span>{/if}
</div>
<style>
  .contact-comparison {
    max-width: 24rem;
    min-width: 12rem;
    width: max-content;
  }
  .contact-comparison :global(.status-tag) {
    max-width: 100%;
  }
  .contact-comparison :global(.status-tag__label) {
    white-space: normal;
    overflow-wrap: anywhere;
  }
  .contact-comparison__hint {
    display: block;
    margin-top: 0.25rem;
    color: var(--text-invers-70);
    font-size: 0.75rem;
  }
  .contact-comparison:focus-visible {
    outline: 2px solid var(--primary-100);
    outline-offset: 3px;
  }
</style>
